export const COMPANY_INFO_KEY = Symbol("companyInfo");
export const PRODUCT_CODE_INFO_KEY = Symbol("productCodeInfo");
export const EXCEL_EXPORT_OPTIONS_KEY = Symbol("excelExportOptions");
/**
 * @description Vue 플러그인으로 ERP 정보 등록
 */
const ERPInfoPlugin = {
    install(vue, options) {
        if (!options) {
            console.error("ERP 정보가 초기화되지 않았습니다.");
            throw new Error("ERP 정보가 초기화되지 않았습니다.");
        }
        const { companyInfo, codeInfo, excelExportOptions } = options;
        vue.prototype.$companyInfo = companyInfo;
        vue.prototype.$productCodeInfo = codeInfo;
        vue.prototype.$excelExportOptions = excelExportOptions;
        vue.mixin({
            provide() {
                return {
                    [COMPANY_INFO_KEY]: companyInfo,
                    [PRODUCT_CODE_INFO_KEY]: codeInfo,
                    [EXCEL_EXPORT_OPTIONS_KEY]: excelExportOptions,
                };
            },
        });
    },
};
export default ERPInfoPlugin;
